document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".card-to-sliders-people");
  const BREAKPOINT = 768;

  sections.forEach((section) => {
    const cardSwiper = section.querySelector(".icon-cards-swiper");
    if (!cardSwiper) return;

    const slides = cardSwiper.querySelectorAll(".swiper-slide");
    const prevEl = section.querySelector(".swiper-controls .prev");
    const nextEl = section.querySelector(".swiper-controls .next");
    const hasMultipleSlides = slides.length > 1;

    let swiperInstance = null;

    function initSwiper() {
      if (swiperInstance || window.innerWidth >= BREAKPOINT) return;

      swiperInstance = new Swiper(cardSwiper, {
        loop: hasMultipleSlides,
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: false,
        allowTouchMove: true,
        speed: 800,
        watchOverflow: true,
        navigation:
          hasMultipleSlides && prevEl && nextEl
            ? { nextEl, prevEl }
            : undefined,
      });
    }

    function destroySwiper() {
      if (!swiperInstance) return;
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }

    function handleResize() {
      if (window.innerWidth < BREAKPOINT) {
        initSwiper();
      } else {
        destroySwiper();
      }
    }

    handleResize();
    window.addEventListener("resize", handleResize);
  });
});
